<template>
	<div class="container-full">
		<myHeader></myHeader>
		<div class="banner">
			<img :src="baseUrl+infoData.data.massifImg">
		</div>
		<div class="main">
			<!-- 			<div class="title">
				{{ introTitle }}
			</div> -->
			<div class="massifs-detail">
				
				<div class="info">
					<el-descriptions class="margin-top" :title="introTitle" :column="2" size="default" border>
						<el-descriptions-item :span="2">
							<template #label>
								<div class="cell-item">
									用地性质:
								</div>
							</template>
							<el-tag size="default">{{ infoData.data.massifCharacter }}</el-tag>
						</el-descriptions-item>
						<el-descriptions-item>
							<template #label>
								<div class="cell-item">
									用地面积:
								</div>
							</template>
							{{ infoData.data.massifArea }}亩
						</el-descriptions-item>
						<el-descriptions-item>
							<template #label>
								<div class="cell-item">
									容积率:
								</div>
							</template>
							{{ infoData.data.massifPlotRatio }}
						</el-descriptions-item>
						<el-descriptions-item>
							<template #label>
								<div class="cell-item">
									建筑密度:
								</div>
							</template>
							{{ infoData.data.massifBuildingDensity }}%
						</el-descriptions-item>
						<el-descriptions-item>
							<template #label>
								<div class="cell-item">
									绿地率:
								</div>
							</template>
							{{ infoData.data.massifGreeningRate }}%
						</el-descriptions-item>
						<el-descriptions-item>
							<template #label>
								<div class="cell-item">
									宗地位置:
								</div>
							</template>
							{{ infoData.data.massifPosition }}
						</el-descriptions-item>
					</el-descriptions>
				</div>
				<div class="content" v-html="infoData.data.massifContent"></div>
			</div>
		</div>
		<!-- 尾部 -->
		<myFooter></myFooter>
		<!-- 侧边悬浮 -->
		<sideFloat></sideFloat>
		<!-- 底部菜单 -->
		<bottomMenu></bottomMenu>
	</div>
</template>

<script>
	import {
		useRoute
	} from 'vue-router';
	import {
		parkDetail
	} from '../axios/api.js';
	import {
		ElMessage
	} from 'element-plus';
	import {
		onMounted,
		reactive
	} from 'vue';
	import myHeader from '@/components/layouts/myHeader'
	import myFooter from '@/components/layouts/myFooter'
	import bottomMenu from '@/components/layouts/bottomMenu'
	import sideFloat from '@/components/layouts/sideFloat'
	export default {
		components: {
			myHeader,
			myFooter,
			bottomMenu,
			sideFloat
		},
		setup() {
			const route = useRoute();
			const infoData = reactive({
				data: {}
			});
			let introTitle = route.query.title;
			const baseUrl = 'https://ysdtapi.cdssjj.changde.gov.cn/cdMapApi';

			//获取详情页数据
			function getData() {
				console.log('marksId:route.query.query')
				parkDetail('/cdMapApi/api/massifs/getDetailByMarksId', {
					marksId: route.query.query
				}).then(function(res) {
					let {
						code,
						data,
						msg
					} = res.data;

					if (code == 200) {
						// console.log("详情:", data);
						infoData.data = data;
					} else {
						ElMessage({
							offset: 100,
							type: 'error',
							message: msg
						});
					}
				}).catch(function(error) {
					console.log(error);
				})
			}

			onMounted(() => {
				getData()
			})

			return {
				infoData,
				introTitle,
				baseUrl
			}
		}
	}
</script>

<style lang="scss">
	.container-full {
		.banner {
			img {
				width: 100%;
			}
		}

		.main {
			
			.massifs-detail {
				padding: 15px;
				
				.title {
					font-size: 20px;
				}
				
				.info {
					.el-descriptions__title {
						font-size: 18px;
					}
				
					.el-descriptions__label {
						width: 83px;
				
						.cell-item {
							width: 60px;
						}
					}
				}
				
				.content {
					margin: 15px 0px;
					
					img {
						width: 100%!important;
						height: auto!important;
					}
				}
			}
		}
	}
</style>